import styled from "@emotion/styled";

export const AppFooterWrapper = styled.footer`
  box-sizing: border-box;
  padding: 16px 0 46px;
  background: #000;

  .container {
    max-width: 1468px;
    margin: 0 auto;
    padding: 0 16px;
  }

  .privacy {
    gap: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    flex-wrap: wrap;

    @media (max-width: 768px) {
      flex-direction: column;
      align-items: center;
      text-align: center;
      gap: 20px;
    }

    p {
      font-weight: 600;
      font-size: 14px;
      line-height: 14px;
      color: #badaff;
      margin: 0 52px 0 0;
      text-transform: uppercase;

      @media (max-width: 768px) {
        margin: 0;
        font-size: 12px;
        order: 3;
      }
    }

    a {
      display: block;
      position: relative;
      font-weight: 600;
      font-size: 14px;
      line-height: 14px;
      color: #badaff;
      text-decoration: none;
      transition: all 0.3s ease;

      @media (max-width: 768px) {
        font-size: 13px;
      }

      &:before {
        content: "";
        position: absolute;
        display: block;
        height: 2px;
        width: 100%;
        bottom: -4px;
        background-color: #afafaf;
        transition: all 0.3s ease;
      }
      &:hover {
        color: var(--accent-color);
        &:before {
          background-color: var(--accent-color);
        }
      }
    }
  }

  .links-wrapper {
    display: flex;
    gap: 16px;

    @media (max-width: 768px) {
      order: 1;
    }
  }

  .payment-icons {
    display: flex;
    align-items: center;
    gap: 8px;

    @media (max-width: 768px) {
      order: 2;
      margin-right: 0 !important;
    }

    img {
      width: 54px;

      @media (max-width: 480px) {
        width: 44px;
      }
    }
  }

  @media (max-width: 768px) {
    padding: 24px 0 32px;
  }
`;
